import { ExportColumn } from '../types';
import { resolveNormalizedColumnType } from './resolveNormalizedColumnType';

const STRING_EXPORT_TYPES = ['string', 'text', 'memo', 'char', 'varchar'];

export const isStringExportColumn = (column: ExportColumn): boolean => {
  const normalizedType = resolveNormalizedColumnType(column);

  return (
    normalizedType === '' ||
    STRING_EXPORT_TYPES.some((type) => normalizedType.includes(type))
  );
};
